module.exports = __webpack_public_path__ + "static/media/icon-user-group-small.ab0b339a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-user-group-small.svg
// module id = 1725
// module chunks = 0